<form *ngIf="formInitialized" [formGroup]="form" (ngSubmit)="onSubmit()" class="p-fluid">
  <app-header icon="fas fa-city" text="Name"></app-header>
  <div class="grid">
    <app-form-field-wrapper [label]="'Name'" [name]="'name'" [colSize]="8" [formField]="form.get('name')">
      <input pInputText id="name" type="text" formControlName="name" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Gemeindeschlüssel'" [name]="'key'" [colSize]="4" [formField]="form.get('key')">
      <input pInputText id="key" type="text" formControlName="key" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Atlas-Titel'" [name]="'title'" [colSize]="12" [formField]="form.get('title')">
      <input pInputText id="title" type="text" formControlName="title" class="p-input" />
    </app-form-field-wrapper>
  </div>
  <p-divider />
  <app-header icon="fas fa-address-card" text="Verantwortliche Person"></app-header>
  <div class="grid">
    <app-form-field-wrapper [label]="'Vorname'" [name]="'contactPersonFirstName'" [colSize]="6"
      [formField]="form.get('contactPersonFirstName')">
      <input pInputText id="contactPersonFirstName" type="text" formControlName="contactPersonFirstName"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Nachname'" [name]="'contactPersonLastName'" [colSize]="6"
      [formField]="form.get('contactPersonLastName')">
      <input pInputText id="contactPersonLastName" type="text" formControlName="contactPersonLastName"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Funktion'" [name]="'contactPersonRole'" [colSize]="6"
      [formField]="form.get('contactPersonRole')">
      <input pInputText id="contactPersonRole" type="text" formControlName="contactPersonRole" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Organisation'" [name]="'organisation'" [colSize]="6"
      [formField]="form.get('organisation')">
      <input pInputText id="organisation" type="text" formControlName="organisation" class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Straße & Haus-Nr.'" [name]="'street'" [colSize]="6"
      [formField]="form.get('street')">
      <input pInputText id="street" type="text" formControlName="street" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'PLZ'" [name]="'zip'" [colSize]="2" [formField]="form.get('zip')">
      <input pInputText id="zip" type="text" formControlName="zip" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Stadt'" [name]="'city'" [colSize]="4" [formField]="form.get('city')">
      <input pInputText id="city" type="text" formControlName="city" class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Telefon'" [name]="'contactPersonPhone'" [colSize]="5"
      [formField]="form.get('contactPersonPhone')">
      <input pInputText id="contactPersonPhone" type="text" formControlName="contactPersonPhone" class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'E-Mail-Adresse'" [name]="'contactPersonMail'" [colSize]="7"
      [formField]="form.get('contactPersonMail')">
      <input pInputText id="contactPersonMail" type="text" formControlName="contactPersonMail" class="p-input" />
    </app-form-field-wrapper>
  </div>
  <p-divider></p-divider>
  <app-header icon="fas fas fa-at" text="Kontakt"></app-header>
  <div class="grid">
    <app-form-field-wrapper [label]="'Kontakt-Url (extern)'" [name]="'contactUrl'" [colSize]="12"
      [formField]="form.get('contactUrl')">
      <input pInputText id="contactUrl" type="text" formControlName="contactUrl" class="p-input" />
    </app-form-field-wrapper>
  </div>
  <p-divider></p-divider>
  <app-header icon="fas fa-link" text="Link zum öffentlichen Atlas"></app-header>
  <div class="grid">
    <app-form-field-wrapper [name]="'slug'" [colSize]="12" [formField]="form.get('slug')">
      <p-inputGroup class="w-full">
        <p-inputGroupAddon> https://kommunal-atlas.de/ </p-inputGroupAddon>
        <input type="text" pInputText placeholder="ihr-kommunen-name" formControlName="slug" />
        <button [disabled]="!form.value.name" type="button" (click)="generateSlug()" pButton icon="fas fa-rotate"
          class="p-button-secondary"></button>
        <button [disabled]="!form.value.slug" type="button" (click)="copyAtlasUrlToClipboard()" pButton
          icon="fas fa-copy" class="p-button-primary"></button>
      </p-inputGroup>
    </app-form-field-wrapper>
  </div>
  <p-divider></p-divider>
  <app-header icon="fas fa-unlock" text="Status"></app-header>
  <div class="grid">
    <app-form-field-wrapper [label]="'Freigegeben'" [name]="'locked'" [colSize]="4">
      <p-inputSwitch [falseValue]="true" [trueValue]="false" formControlName="locked"></p-inputSwitch>
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Zwei-Faktor-Authentisierung'" [name]="'twoFactorAuth'" [colSize]="8">
      <p-inputSwitch formControlName="twoFactorAuth"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider></p-divider>
  <app-form-footer [hideCancelLink]="true" [showRemoveButton]="!!itemToEdit" [isEditMode]="!!itemToEdit" (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
    "></app-form-footer>
</form>